module.exports = __webpack_public_path__ + "static/media/video-placeholder.1a0b548f.png";